import { Button } from '@/components/ui/button'
import { useActiveOrg } from '@/hooks/use-active-org'
import { Settings } from 'lucide-react'
import { useNavigate } from 'react-router'

const OnboardNotification = () => {
  const navigate = useNavigate()
  const { activeOrg } = useActiveOrg()

  if (activeOrg?.isOnboardingCompleted === undefined) return null
  if (activeOrg?.isOnboardingCompleted) return null

  return (
    <div>
      <div className='mb-4 p-5 bg-accent/50 border border-border  rounded-lg '>
        <div className='flex items-center gap-4 w-full'>
          <div className='flex-1 min-w-0'>
            <div className='flex items-start gap-2 mb-2'>
              <div>
                <h3 className='text-base font-semibold text-foreground '>Complete Your Organization Setup</h3>
                <p className='text-sm text-muted-foreground leading-relaxed'>
                  Select at least one module to finish setup. You cannot use the platform until onboarding is complete.
                </p>
              </div>
            </div>
            <div className='flex flex-wrap gap-2 mt-2'>
              <Button
                onClick={() => navigate(`/on-boarding/${activeOrg?.id}`)}
                size='sm'
                variant='default'
                className='shadow-sm'
              >
                <Settings className='h-4 w-4' />
                Continue Setup
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default OnboardNotification
